import React from 'react';
import { Typography } from '@mui/material';
import { palette } from '../../../../../assets/styles/themes/tokens';
import { getDateTimeInGermanFormat } from '../../../../../utils/format';
import { useTranslation } from 'react-i18next';

interface ArtifactCardSubheaderProps {
  createdAt?: number;
}

const ArtifactCardSubheader: React.FC<ArtifactCardSubheaderProps> = ({ createdAt }) => {
  const { t } = useTranslation();

  if (!createdAt) return null;

  return (
    <Typography variant='caption2' sx={{ color: palette.text.secondary }}>
      {t('Created') + ' • ' + getDateTimeInGermanFormat(createdAt)}
    </Typography>
  );
};

export default ArtifactCardSubheader;
